export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13453.1c6460d8.jpg";